(function () {
  // Deux corrections sur la fiche produit.
  //
  // 1. Le bouton d'achat tombe a 1295 px sur un ecran de 900 et a 1359 px sur mobile : il faut
  //    scroller une fenetre et demie avant de pouvoir acheter. On pose une barre d'achat fixe qui
  //    ne fait que relayer le clic vers le vrai bouton, pour que la validation photo continue de
  //    s'appliquer telle quelle.
  //
  // 2. Le bloc de notation est masque sur le kit personnalise alors qu'il porte deux avis reels
  //    (textContent : "5.0 / 5.0 (2) 2 total reviews"). On l'affiche quand il y a au moins un avis,
  //    on le retire quand il n'y en a pas, et on redonne sa lisibilite a la note chiffree que le
  //    theme masque. Lecture sur textContent : innerText retombe sur textContent des que l'element
  //    n'est pas rendu, donc il ne permet pas de distinguer les deux cas.

  if (!/\/products\//.test(location.pathname)) return;

  function vraiBouton() {
    var b = document.querySelectorAll('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"]');
    for (var i = 0; i < b.length; i++) {
      var t = b[i].innerText || b[i].value || "";
      if (/add to cart|ajouter au panier/i.test(t) && b[i].offsetParent !== null) return b[i];
    }
    return null;
  }

  function notation() {
    var e = document.querySelector(".rating-fake-sales");
    if (!e) return;
    var brut = (e.textContent || "").replace(/\s+/g, " ").trim();
    var m = brut.match(/(\d+)\s*total reviews?/i) || brut.match(/\((\d+)\)/);
    var nb = m ? parseInt(m[1], 10) : 0;
    if (!nb) { e.style.setProperty("display", "none", "important"); return; }
    e.style.setProperty("display", "flex", "important");
    e.style.setProperty("align-items", "center", "important");
    e.style.setProperty("gap", ".4rem", "important");
    var texte = e.querySelector(".rating-text");
    if (texte) {
      texte.style.setProperty("display", "inline-block", "important");
      texte.style.setProperty("margin", "0", "important");
    }
    var compte = e.querySelector(".rating-count");
    if (compte) compte.style.setProperty("margin", "0", "important");
  }

  function prixAffiche() {
    var zone = document.querySelector(".price__container, .price, [class*=price-item]");
    var t = zone ? (zone.textContent || "").replace(/\s+/g, " ") : "";
    // "From 17,95" tant qu'aucune variante n'est choisie : on garde le qualificatif, sinon la barre
    // annonce un prix plus bas que celui qui partira au panier.
    var m = t.match(/(From|A partir de|À partir de)?\s*((?:[$€£¥]\s?\d[\d\s.,]*|\d[\d\s.,]*\s?(?:USD|EUR|GBP|CAD|AUD)))/);
    if (!m) return "";
    return ((m[1] ? m[1] + " " : "") + m[2]).trim();
  }

  function majPrix() {
    var p = document.querySelector("#abn-barre-achat .abn-barre-prix");
    if (p) { var v = prixAffiche(); if (v) p.textContent = v; }
  }

  function barre() {
    // Le theme pose deja une barre d'achat fixe : snippets/abn-mobile-sticky-atc.liquid (#abn-msticky,
    // z-index 1999000, prix de la variante choisie). Deux barres empilees en bas de l'ecran, c'est du
    // doublon visuel et deux relais de clic vers le meme bouton. Celle-ci s'efface devant celle du theme.
    if (document.getElementById("abn-msticky")) return;
    if (document.getElementById("abn-barre-achat")) { majPrix(); return; }
    var cible = vraiBouton();
    if (!cible) return;

    var titre = document.querySelector("h1");
    var d = document.createElement("div");
    d.id = "abn-barre-achat";
    d.innerHTML =
      '<div class="abn-barre-texte"><span class="abn-barre-titre"></span><span class="abn-barre-prix"></span></div>' +
      '<button type="button" class="abn-barre-bouton">ADD TO CART</button>';
    d.querySelector(".abn-barre-titre").textContent = titre ? (titre.innerText || "").trim().slice(0, 46) : "";
    d.querySelector(".abn-barre-prix").textContent = prixAffiche();

    var css = document.createElement("style");
    css.textContent =
      "#abn-barre-achat{position:fixed;left:0;right:0;bottom:0;z-index:998;display:flex;align-items:center;" +
      "gap:1rem;padding:.7rem 1rem;background:#fff;border-top:1px solid rgba(0,0,0,.12);" +
      "box-shadow:0 -2px 12px rgba(0,0,0,.08);transform:translateY(110%);transition:transform .25s ease}" +
      "#abn-barre-achat.abn-visible{transform:translateY(0)}" +
      ".abn-barre-texte{flex:1;min-width:0;display:flex;flex-direction:column;line-height:1.25}" +
      ".abn-barre-titre{font-size:.85rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      ".abn-barre-prix{font-size:1rem;font-weight:600}" +
      ".abn-barre-bouton{flex:0 0 auto;padding:.85rem 1.6rem;border:0;border-radius:6px;cursor:pointer;" +
      "background:#1a1a1a;color:#fff;font-size:.9rem;letter-spacing:.04em}" +
      "@media(min-width:768px){#abn-barre-achat{padding:.75rem 3rem}.abn-barre-bouton{padding:.9rem 2.4rem}}" +
      "@media(max-width:767px){#abn-barre-achat{padding-bottom:calc(.7rem + env(safe-area-inset-bottom))}}";
    document.head.appendChild(css);
    document.body.appendChild(d);

    d.querySelector(".abn-barre-bouton").addEventListener("click", function () {
      var b = vraiBouton();
      if (!b) return;
      b.click(); // le controle photo est pose sur le document, il s'applique donc aussi a ce clic
    });

    // le prix suit la variante choisie (taille, cadre)
    document.addEventListener("change", function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('form[action*="/cart/add"], .bcpo-form, variant-selects')) {
        setTimeout(majPrix, 500);
      }
    }, true);

    var obs = new IntersectionObserver(function (entrees) {
      d.classList.toggle("abn-visible", !entrees[0].isIntersecting);
    }, { threshold: 0.4 });
    obs.observe(cible);
  }

  function demarrer() { notation(); barre(); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
  // l'app d'options redessine une partie de la fiche apres coup
  setTimeout(demarrer, 2500);
  setTimeout(demarrer, 6000);
})();
